import { Tooltip } from 'antd';
import React from 'react';
import type { ICustomTooltipProps } from './types';

export const CustomTooltip = ({
  children,
  title,
  placement,
  classNames,
  arrow,
  trigger,
  open,
  mouseEnterDelay,
  mouseLeaveDelay,
  getPopupContainer,
  align,
}: ICustomTooltipProps): React.JSX.Element => (
  <Tooltip
    title={title}
    placement={placement}
    classNames={classNames}
    arrow={arrow}
    trigger={trigger}
    open={open}
    mouseEnterDelay={mouseEnterDelay}
    mouseLeaveDelay={mouseLeaveDelay}
    getPopupContainer={getPopupContainer}
    align={align}
  >
    {children}
  </Tooltip>
);

export default CustomTooltip;
